module.exports = __webpack_public_path__ + "static/media/multiplication.5e533666.svg";